import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

import PDFSVG from '../../assets/icons/pdfIcon.svg';
import {
  Avatar,
  Divider,
  ListImage,
  Paragraph,
  Timeline,
  Typography,
} from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import {
  TechnicianJobDetailsContainerStyled,
  UploadedLogosContainerStyled,
} from './style';

type Props = {
  jobDetails: {
    jobCreatedAt: string;
    jobTitle: string;
    notes: string;
    buildingId: string;
    buildingName: string;
    addressOfProperty: string;
    jobCreatedByName: string;
    jobCreatedByAvatar: string;
    jobCreatedByEmail: string;
    sizeOfDrawing: string;
    frameColor: string;
    uploadedLogos: { URL: string; id: string }[];
    blueprints: { URL: string; id: string }[];
    resolutionOfLogo: string;
    materialTypeOfDrawing: string;
    roundedEdge: string;
    pdfReceatedCount?: number;
    additionalInfo: { title: string; value: string }[];
    shippingAddress?: string;
    proposalSentAt?: string;
    proposalAcceptedAt?: string;
    contractGeneratedAt?: string;
    contractAcceptedAt?: string;
  };
};

const JobInformation = ({ jobDetails }: Props) => {
  const {
    jobCreatedAt,
    jobTitle,
    notes,
    addressOfProperty,
    buildingName,
    jobCreatedByName,
    jobCreatedByEmail,
    jobCreatedByAvatar,
    sizeOfDrawing,
    frameColor,
    uploadedLogos,
    resolutionOfLogo,
    materialTypeOfDrawing,
    roundedEdge,
    blueprints,
    // pdfReceatedCount,
    additionalInfo,
    shippingAddress,
    proposalSentAt,
    proposalAcceptedAt,
    contractGeneratedAt,
    contractAcceptedAt,
  } = jobDetails;

  console.log(jobDetails, 'jobDetials');
  const events = [
    {
      date: jobCreatedAt,
      title: 'Job Created ',
    },
    {
      date: typeof proposalSentAt !== 'undefined' ? proposalSentAt : '',
      title: 'Proposal Sent ',
    },
    {
      date: typeof proposalAcceptedAt !== 'undefined' ? proposalAcceptedAt : '',
      title: 'Proposal Accepted ',
    },
    {
      date:
        typeof contractGeneratedAt !== 'undefined' ? contractGeneratedAt : '',
      title: 'Contract Generated ',
    },
    {
      date: typeof contractAcceptedAt !== 'undefined' ? contractAcceptedAt : '',
      title: 'Contract Accepted ',
    },
  ];

  return (
    <TechnicianJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        JOB INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Job Create At :
          </Typography>
          <Typography className="value">{jobCreatedAt}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Job Title :
          </Typography>
          <Typography className="value">{jobTitle}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title" fontColor="dark">
            Notes :
          </Typography>
          <div className="value">
            <Paragraph text={notes} />
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
      <Divider spaceY="20px" />
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        PROPERTY INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Building Name :</Typography>
          <Typography className="value">{buildingName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Address of Property :</Typography>
          <Typography className="value">{addressOfProperty}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
      <Divider spaceY="20px" />
      <Typography
        variant="normal"
        className="section-title"
        fontColor="secondary"
        strong
      >
        JOB CREATED BY
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Name : </Typography>

          <div className="value">
            <Avatar
              size="md"
              src={jobCreatedByAvatar}
              style={{ marginTop: '-4px' }}
            />
            <Typography className="value">{jobCreatedByName}</Typography>
          </div>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Email Address :</Typography>

          <Typography className="value">{jobCreatedByEmail}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
      <Divider spaceY="20px" />
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        CLIENT REQUIREMENT
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Size of Drawing :</Typography>
          <Typography className="value">{sizeOfDrawing}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Selected Frame Color :</Typography>
          <Typography className="value">{frameColor}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title">Blueprints :</Typography>
          <UploadedLogosContainerStyled className="value">
            {blueprints.map((img, idx) => {
              const condition = img?.URL?.split('.');
              if (
                condition.includes('svg') ||
                condition.includes('png') ||
                condition.includes('jpeg') ||
                condition.includes('jpg')
              ) {
                return (
                  <div key={idx}>
                    <ListImage
                      imagesURL={[img]}
                      imageHeight="143px"
                      imageWidth="192px"
                    />
                  </div>
                );
              } else if (condition.includes('pdf')) {
                return (
                  <div style={{ position: 'relative' }} key={idx}>
                    <div>
                      <img src={PDFSVG} alt="pdf icon" />
                    </div>
                    <Link
                      style={{
                        position: 'absolute',
                        top: '0px',
                        left: '80px',
                        cursor: 'pointer',
                      }}
                      to={img.URL}
                      target="_blank"
                    >
                      <FaArrowUpRightFromSquare color="dimgray" size={15} />
                    </Link>
                  </div>
                );
              }
            })}
          </UploadedLogosContainerStyled>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title">Uploaded Logo :</Typography>
          <UploadedLogosContainerStyled className="value">
            <ListImage
              imagesURL={uploadedLogos}
              imageHeight="143px"
              imageWidth="192px"
            />
          </UploadedLogosContainerStyled>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Resolution of Logo :</Typography>
          <Typography className="value">{resolutionOfLogo}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Material Type of Drawing :</Typography>
          <Typography className="value">{materialTypeOfDrawing}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Rounded Edge :</Typography>
          <Typography className="value">{roundedEdge}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
      <Divider spaceY="20px" />
      {additionalInfo.length !== 0 ? (
        <>
          <Typography
            variant="normal"
            strong
            fontColor="secondary"
            className="section-title"
          >
            ADDITIONAL REQUIREMENT
          </Typography>
          <VerticalSpaceStyled>
            {additionalInfo.map((val) => (
              <InfoRowStyled key={val.value}>
                <Typography className="title">{val.title}</Typography>
                <Paragraph
                  className="value"
                  text={val.value}
                  numberOfLines={3}
                />
              </InfoRowStyled>
            ))}
          </VerticalSpaceStyled>
          <Divider spaceY="20px" />
        </>
      ) : (
        ''
      )}
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        SHIPPING ADDRESS
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Address:</Typography>
          <Typography className="value">{shippingAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>

      <Divider spaceY="20px" />
      <InfoRowStyled>
        <div className="value">
          <Timeline events={events} />
        </div>
      </InfoRowStyled>
      {/* <Divider spaceY="20px" />
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        PDF RECREATION INFORMATION{' '}
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">PDF Recreate Count :</Typography>
          <Typography className="value">{pdfReceatedCount}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled> */}
    </TechnicianJobDetailsContainerStyled>
  );
};

export default JobInformation;
